import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './ui.css';

export interface FilterChip {
  key: string;
  label: string;
  onRemove: () => void;
}

interface AdminFilterBarProps {
  children: React.ReactNode;
  chips?: FilterChip[];
  onClearAll?: () => void;
  resultCount?: number;
  resultLabel?: string;
}

const AdminFilterBar: React.FC<AdminFilterBarProps> = ({ children, chips = [], onClearAll, resultCount, resultLabel }) => (
  <div className="admin-filter-bar">
    <div className="admin-filter-bar__row">
      {children}
      {onClearAll && chips.length > 0 && (
        <button type="button" className="admin-filter-bar__clear-all" onClick={onClearAll}>
          Limpar tudo
        </button>
      )}
    </div>

    <AnimatePresence initial={false}>
      {chips.length > 0 && (
        <motion.div
          className="admin-filter-bar__chips"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.18 }}
        >
          {chips.map((chip) => (
            <motion.span
              key={chip.key}
              className="admin-filter-chip"
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.15 }}
            >
              {chip.label}
              <button type="button" onClick={chip.onRemove} aria-label={`Remover filtro ${chip.label}`}>
                ×
              </button>
            </motion.span>
          ))}
        </motion.div>
      )}
    </AnimatePresence>

    {resultCount !== undefined && (
      <span className="admin-result-count">
        {resultCount} {resultLabel ?? (resultCount === 1 ? 'resultado' : 'resultados')}
      </span>
    )}
  </div>
);

export default AdminFilterBar;

interface AdminSearchFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const AdminSearchField: React.FC<AdminSearchFieldProps> = ({ id, label, value, onChange, placeholder }) => (
  <div className="admin-filter-field admin-filter-field--search">
    <label htmlFor={id}>{label}</label>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
    <input
      id={id}
      type="text"
      className="admin-input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={label}
    />
  </div>
);
